import logo from "./logo.svg";
import "./App.css";
import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import PinView from "./PinView";
import config from "./config";

// Spinner component for loading state


function CardDetails() {
  const [error, setError] = useState(false);

  useEffect(() => {
    getCardDetails();
  }, []);

  async function getCardDetails() {
    try {
      const stripePromise = await loadStripe(config.STRIPE_PUBLIC_KEY);

      // Initialize Elements which you'll need later
      const elements = stripePromise.elements();

      const cardId = getUrlParameter("cardId"); // get it from params
      
      if (!cardId) {
        setError(true);
        return;
      }

      // Use Stripe.js to create a nonce
      const nonceResult = await stripePromise.createEphemeralKeyNonce({
        issuingCard: cardId,
      });

      const epmKey = getUrlParameter("epmkey"); // get it from params
      
      if (!epmKey) {
        setError(true);
        return;
      }

      const number = elements.create("issuingCardNumberDisplay", {
        issuingCard: cardId,
        nonce: nonceResult.nonce,
        ephemeralKeySecret: epmKey,
        style: {
          base: {
            color: "#333333",
            fontSize: "20px",
          },
        },
      });

      const cardExpiry = elements.create("issuingCardExpiryDisplay", {
        issuingCard: cardId,
        nonce: nonceResult.nonce,
        ephemeralKeySecret: epmKey,
        style: {
          base: {
            color: "#333333",
            fontSize: "20px",
          },
        },
      });

      const cardCvv = elements.create("issuingCardCvcDisplay", {
        issuingCard: cardId,
        nonce: nonceResult.nonce,
        ephemeralKeySecret: epmKey,
        style: {
          base: {
            color: "#333333",
            fontSize: "20px",
          },
        },
      });

      number.mount("#card-number");
      cardExpiry.mount("#card-expiry");
      cardCvv.mount("#card-cvv");
    } catch (err) {
      setError(true);
    }
  }

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  return (
    <div className="App">
      <header className="App-header">
        {error ? (
          <div style={{color: '#cc0000', fontSize: '20px'}}>Something went wrong</div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f9f9f9",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.08)",
              width: "220px",
              pointerEvents: "none"
            }}
          >
            <div
              style={{
                width: "100%",
                border: "1px solid #ddd",
                borderRadius: "6px",
                padding: "12px",
                backgroundColor: "white",
                minHeight: "25px",
                marginBottom: "15px",
                pointerEvents: "none"
              }}
              id="card-number"
            ></div>
            
            <div
              style={{
                width: "100%",
                border: "1px solid #ddd",
                borderRadius: "6px",
                padding: "12px",
                backgroundColor: "white",
                minHeight: "25px",
                marginBottom: "15px",
                pointerEvents: "none"
              }}
              id="card-expiry"
            ></div>
            
            <div
              style={{
                width: "100%",
                border: "1px solid #ddd",
                borderRadius: "6px",
                padding: "12px",
                backgroundColor: "white",
                minHeight: "25px",
                pointerEvents: "none"
              }}
              id="card-cvv"
            ></div>
          </div>
        )}
      </header>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CardDetails />} />
        <Route path="/viewpin" element={<PinView />} />
      </Routes>
    </Router>
  );
}

export default App;
